import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "subway"
const SubwayIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2a9 9 0 0 1 9 9v9.008c0 1.1-.893 1.992-1.995 1.992H4.995C3.893 22 3 21.1 3 20.008V11a9 9 0 0 1 9-9Zm6 18v-1H6v1h12Zm-8-3v1H8v-1h-.005A.992.992 0 0 1 7 15.997V10c0-2 0-3 5-3s5 1 5 3v5.997c0 .554-.456 1.003-.995 1.003H16v1h-2v-1h-4Zm0-2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM9.5 9a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-5Z"
          />
        </svg>
      }
    </span>
  )
}
export default SubwayIcon
